import { Component, DestroyRef, computed, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterOutlet } from '@angular/router';
import { ErrorService } from '@app/core';
import { MatomoService } from './core/services/matomo.service';
import { PosthogService } from './core/services/posthog.service';
import { materialImports } from './shared/material';
import { TranslateService } from './shared/services/translate.service';

@Component({
  selector: 'app-root',
  imports: [...materialImports, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  // Services
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);
  private errorService = inject(ErrorService);
  private matomoService = inject(MatomoService);
  private translate = inject(TranslateService);
  private posthogService = inject(PosthogService);

  // Properties
  public readonly title = 'tirepd-ng';

  // Signals
  private readonly currentLang = signal<string | null>(null);
  public readonly isLoading = computed(() => !this.currentLang());

  constructor() {
    // Clear the error box
    this.errorService.clear();
    // Initialize analytics
    this.posthogService.init();
    this.posthogService.capture(this.router);
    this.matomoService.init();

    // Listen to language changes and update signal
    this.translate.onLangChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((event) => {
      this.currentLang.set(event.lang);
    });
  }
}
